import { Box } from '@miro-site/core';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Categories = function Categories(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height;
  return /*#__PURE__*/_jsxs(Box, {
    as: "svg",
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "4",
      y: "6",
      width: "17",
      height: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "4",
      y: "11",
      width: "17",
      height: "2"
    }), /*#__PURE__*/_jsx("rect", {
      x: "4",
      y: "16",
      width: "11",
      height: "2"
    })]
  });
};

export default Categories;